"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.cellDataGetter = exports.TriggeredAlarmsCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cellDataGetter = function cellDataGetter(_ref) {
  var rowData = _ref.rowData;
  var triggeredAlarms = rowData.triggeredAlarms,
      owningPortal = rowData.owningPortal;
  return {
    triggeredAlarms: triggeredAlarms,
    owningPortal: owningPortal
  };
};

exports.cellDataGetter = cellDataGetter;

var TriggeredAlarmsCell = function TriggeredAlarmsCell(_ref2) {
  var cellData = _ref2.cellData;
  var _cellData$triggeredAl = cellData.triggeredAlarms,
      triggeredAlarms = _cellData$triggeredAl === void 0 ? [] : _cellData$triggeredAl,
      owningPortal = cellData.owningPortal;
  var activePortal = (0, _nicbaseReducers.usePortal)();

  if (owningPortal && activePortal.id === owningPortal.id && triggeredAlarms.length > 0) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, triggeredAlarms.map(function (currentAlarm) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        title: currentAlarm.names.join('\n')
      }, currentAlarm.severity === 'GREEN' ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.WarningGreen, {
        className: "inline-block"
      }) : null, currentAlarm.severity === 'YELLOW' ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.WarningYellow, {
        className: "inline-block"
      }) : null, currentAlarm.severity === 'RED' ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.WarningRed, {
        className: "inline-block"
      }) : null);
    }));
  }

  return null;
};

exports.TriggeredAlarmsCell = TriggeredAlarmsCell;
TriggeredAlarmsCell.propTypes = {
  cellData: _propTypes["default"].shape({
    triggeredAlarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      severity: _propTypes["default"].string,
      names: _propTypes["default"].arrayOf(_propTypes["default"].number)
    })),
    owningPortal: _propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired
    }).isRequired
  })
};
TriggeredAlarmsCell.defaultProps = {
  cellData: {}
};
var _default = TriggeredAlarmsCell;
exports["default"] = _default;